import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// Google Analytics Tracker
import Tracker from "useTracking.js"
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
// sections of this Page
import SectionFeatures from "./Sections/SectionFeatures.js";
import SectionSocialNetwork from "./Sections/SectionSocialNetwork.js";
import SectionEmailSubscription from "views/ContactUsPage/Sections/SubscribeLine.js";
import schedulingPageStyle from "assets/jss/material-kit-pro-react/views/schedulingPageStyle.js";

const useStyles = makeStyles(schedulingPageStyle);

export default function SchedulingPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    Tracker();
  });
  const classes = useStyles();
  return (
    <div>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="white"
        changeColorOnScroll={{
          height: 300,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/headers/schedules.jpg")}
        small
        title="Scheduling Lessons"
        description="Let Us Teach Your Children Life Saving Skills Year Around!"
        backgroundPosition={"center center"} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <SectionFeatures />
          <SectionSocialNetwork />
        </div>
      </div>
      <SectionEmailSubscription />
      <Footer theme="white" />
    </div>
  );
}
